// @ts-nocheck
import * as React from "react";

const Twitter: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 30 30">
            <g clipPath="url(#a)">
                <path
                    fill="currentColor"
                    d="M15 0C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15Zm9.741 24.741A13.69 13.69 0 0 1 15 28.777a13.68 13.68 0 0 1-9.742-4.036A13.69 13.69 0 0 1 1.223 15c0-3.68 1.432-7.14 4.035-9.742A13.69 13.69 0 0 1 15 1.223c3.68 0 7.14 1.432 9.741 4.035A13.69 13.69 0 0 1 28.777 15c0 3.68-1.432 7.14-4.036 9.741Z"
                />
            </g>
            <path
                fill="currentColor"
                d="M16.289 13.775 22.099 7h-1.377l-5.045 5.883L11.647 7H7l6.094 8.896L7 23h1.377l5.328-6.212L17.96 23h4.648l-6.32-9.225Zm-1.886 2.199-.617-.886L8.873 8.04h2.115l3.964 5.688.618.886 5.153 7.393h-2.115l-4.205-6.033Z"
            />
            <defs>
                <clipPath id="a">
                    <path fill="#fff" d="M0 0h30v30H0z" />
                </clipPath>
            </defs>
        </svg>
        /* Store Custom Code - End */
    );
};

export default React.memo(Twitter);
